/** 此四要素参考接口txn/checkoutDetail- paymentConfigurationFields 数据结构返回 */
export const cardPaymentFields = [
  {
    name: 'cardHolderName',
    require: 'Y',
    value: '',
    display: 'Y',
  },
  {
    name: 'cardNum',
    require: 'Y',
    value: '',
    display: 'Y',
  },
  {
    name: 'cvv',
    require: 'Y',
    value: '',
    display: 'Y',
  },
  {
    name: 'effectiveDate',
    require: 'Y',
    value: '',
    display: 'Y',
  },
];

/** 卡支付四要素默认展示&必填 */
/** 从数据层面实现兜底展示 */
/**
 * @param {Object} data 接口返回数据的data
 * @returns {Object} 返回初始化后的数据
 */
export const initCardPaymentFields = (data) => {
  // 基础字段的名称集合
  const basicFields = new Set(cardPaymentFields.map(field => field.name));

  // 从API返回的字段中过滤出非基础字段(排除cardPaymentFields中的字段)
  const otherApiFields = (data?.paymentConfigurationFields || []).filter(
    field => !basicFields.has(field.name),
  );

  // 合并字段：cardPaymentFields优先(强制使用这四个)，然后添加API返回的其他字段
  const finalFields = [...cardPaymentFields, ...otherApiFields];

  return {
    ...data,
    paymentConfigurationFields: finalFields,
  };
};
